export const STORAGE_KEYS = {
  BILLING: "checkout.billing.v1",
  BILLING_ATTACHMENTS: "checkout.billing.attachments.v1",
  PICKUP_DELIVERY: "checkout.pickupDelivery.v1",
  PAYMENT: "checkout.payment.v1",
  CART_PICKUP_DELIVERY: "cart.pickupDelivery.v1",
  ORDER_FILTERS: "order.filters.v1",
  ORDER_ADVANCED_SEARCH: "order.advanced.search.v1",
  ORDER_PAGE_SIZE: "order.page.size.v1",
  ORDER_PAGE_NUMBER: "order.page.v1",
  ORDER_FILTERS_MONTHS: "order.filters.months.v1",
  EAGLEVIEW_ADDRESS_PREFILL: "checkout.eagleViewAddressPrefill.v1",
};

export interface EagleViewAddressPrefill {
  address1: string;
  city: string;
  stateName: string;
  zip: string;
}
